interface Owner {
  name: string
  homepageUrl: string
  docsUrl: string
  helpUrl: string
}

export const OWNER: Owner = {
  name: 'Sporos DAO',
  homepageUrl: 'https://www.sporosdao.xyz/',
  docsUrl: 'https://www.notion.so/SporosDAO-963e89779ebb45c5b717c478ef739627',
  helpUrl: 'https://sporosdao.xyz/support/'
}
